import React from 'react';
import { Users, Store, Palette } from 'lucide-react';
import { targetAudiences } from '../mock';

const iconMap = {
  0: Users,
  1: Store,
  2: Palette
};

const TargetAudience = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-black via-brand-brown/20 to-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-10 w-[600px] h-[600px] bg-brand-olive/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-10 w-[600px] h-[600px] bg-brand-yellow/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-20">
            <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
              Who We Help Succeed
            </h2>
            <p className="text-xl lg:text-2xl text-brand-cream/90 max-w-3xl mx-auto font-light">
              We specialize in empowering businesses and creators who dream big 
              but need the right partner to amplify their voice.
            </p>
          </div>
          
          {/* Audience cards */}
          <div className="grid md:grid-cols-3 gap-8">
            {targetAudiences.map((audience, index) => {
              const Icon = iconMap[index];
              return (
                <div 
                  key={audience.id}
                  className="group bg-gradient-to-br from-brand-brown/60 to-black/90 rounded-3xl p-10 shadow-2xl hover:shadow-brand-olive/20 transition-all duration-500 hover:-translate-y-3 border border-brand-olive/40 backdrop-blur-lg"
                >
                  <div className="mb-8">
                    <div className="w-20 h-20 bg-gradient-to-br from-brand-olive/30 to-brand-yellow/20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                      <Icon className="w-10 h-10 text-brand-yellow group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h3 className="text-3xl font-bold text-white mb-4 tracking-tight">
                      {audience.title}
                    </h3>
                    <p className="text-brand-cream/80 leading-relaxed text-lg">
                      {audience.description}
                    </p>
                  </div>
                  
                  <div className="space-y-3">
                    <p className="text-sm font-bold text-brand-yellow mb-3 uppercase tracking-wider">What You Get:</p>
                    {audience.benefits.map((benefit, idx) => (
                      <div key={idx} className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-brand-yellow rounded-full shadow-lg shadow-brand-yellow/50"></div>
                        <span className="text-brand-cream/90">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
